var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.943 3.19331L16.9248 17.427C16.6969 18.4314 16.1033 18.6814 15.2596 18.2085L10.6606 14.8195L8.44178 16.9541C8.19604 17.1998 7.99102 17.4048 7.5174 17.4048L7.84815 12.7215L16.3712 5.01993C16.7419 4.6899 16.2905 4.50631 15.7954 4.83706L5.25858 11.472L0.722389 10.0519C-0.264144 9.74401 -0.282003 9.06536 0.928125 8.59174L18.6707 1.75602C19.4922 1.44813 20.2109 1.93889 19.943 3.19403V3.19331Z",
    fill: "#BA8926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramGold);
export default __webpack_public_path__ + "static/media/telegram-gold.898162cc41640b8ab7be97335e3cd1f9.svg";
export { ForwardRef as ReactComponent };